import { LoadingState } from '../../commonTypes'
import { UserAccessToFeatures } from '../../Settings/UserRolesConfiguration/userAccessToFeaturesTypes'

export type AccessCardSliceState = {
  accessCardDetailsList: AccessCardDetailsList[]
  selectedCardDetailsList: AccessCardDetailsList
  selectedEmploymentStatus: EmploymentStatus
  isLoading: LoadingState
  listSize: number
  pagination: AccessCardPagination
}
export enum EmploymentStatus {
  'active' = 'Active',
  'inactive' = 'InActive',
}
export type AccessCardDetailsList = {
  id: number
  fullName: string
  departmentName: string
  designation: string
  accessCard: number
}
export type AccessCardFilterOptionsType = {
  searchInput: string
  setSearchInput: React.Dispatch<React.SetStateAction<string>>
  pageSize: number
  setPageSize: React.Dispatch<React.SetStateAction<number>>
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
}
export type AccessCardResponse = {
  list: AccessCardDetailsList[]
  size: number
}

export type AccessCardPagination = {
  startIndex?: number
  endIndex?: number
}

export interface AccessCardDetailsProps extends AccessCardPagination {
  searchStr?: string
  country?: string
  status?: string
}

export type AccessCardTableProps = {
  paginationRange: number[]
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  pageSize: number
  setPageSize: React.Dispatch<React.SetStateAction<number>>
  setToggle: React.Dispatch<React.SetStateAction<string>>
  userAccess: UserAccessToFeatures | undefined
  viewAccess?: boolean
  updateaccess?: boolean
  userEditAccess?: boolean
}
